import { Reveal, Overline } from "./Reveal";

const VOICES = [
  {
    quote: "AdStellar scaled our CTV & OTT branding across premium inventory at CPMs we didn't think were possible — and the CTRs proved it.",
    name: "Rohan Mehta",
    role: "Head of Growth, D2C Brand",
    img: "https://images.unsplash.com/photo-1607990283143-e81e7a2c9349?auto=format&fit=crop&w=160&q=80",
  },
  {
    quote: "Their DSP & SSP integrations gave us brand-safe reach in markets we couldn't crack before. Transparent reporting, real performance.",
    name: "Ananya Iyer",
    role: "Performance Marketing Lead",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?auto=format&fit=crop&w=160&q=80",
  },
  {
    quote: "From user acquisition to retargeting, AdStellar runs our performance engine end to end. Installs up, acquisition costs down.",
    name: "Daniel Fernandes",
    role: "Founder, Fintech App",
    img: "https://images.unsplash.com/photo-1620246499808-d9fe1b7858dc?auto=format&fit=crop&w=160&q=80",
  },
];

export const Testimonials = () => (
  <section id="voices" data-testid="testimonials-section" className="py-28 md:py-40 border-t border-white/10">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="mb-16 md:mb-24">
        <Reveal>
          <Overline>Our Clients</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="testimonials-heading">
            What Brands Say<br />About <span className="italic text-[#8B5CF6]">Our Work</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {VOICES.map((v, i) => (
          <Reveal key={v.name} delay={i * 0.12} y={24}>
            <figure
              className="group h-full bg-[#09090A] p-10 md:p-12 flex flex-col justify-between transition-colors duration-500 hover:bg-[#121214]"
              data-testid={`testimonial-${v.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <blockquote className="font-display text-xl md:text-2xl italic leading-snug text-[#F8F8F8]">
                “{v.quote}”
              </blockquote>
              <figcaption className="mt-10 flex items-center gap-4">
                <div className="w-12 h-12 overflow-hidden grayscale group-hover:grayscale-0 transition-[filter] duration-500">
                  <img src={v.img} alt={v.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <p className="text-sm font-medium">{v.name}</p>
                  <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-[#52525B] mt-1">{v.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
